'use client';

import React from 'react';
import { useTranslations } from 'next-intl';
import { TextAa } from '@phosphor-icons/react';
import { Box, IconButton, Menu, MenuItem } from '@unity/cloud-ui';

import { ThemeContext, type ThemeZoom } from './theme-context';

import themeConstants from './theme-constants';

export const ZoomSwitcher = () => {
  const t = useTranslations();
  const { zoom, setZoom } = React.useContext(ThemeContext);

  const [menuAnchorEl, setMenuAnchorEl] = React.useState<null | HTMLElement>(null);
  const menuOpen = Boolean(menuAnchorEl);

  const handleButtonClick = (event: React.MouseEvent<HTMLButtonElement>): void => {
    setMenuAnchorEl(event.currentTarget);
  };

  const handleMenuClose = (): void => {
    setMenuAnchorEl(null);
  };

  const handleOnChange = (density: ThemeZoom): void => {
    setZoom(density);
    handleMenuClose();
  };

  return (
    <>
      <IconButton
        color="default"
        id="zoom-button"
        aria-controls={menuOpen ? 'zoom-menu' : undefined}
        aria-haspopup="true"
        aria-expanded={menuOpen ? 'true' : undefined}
        aria-label={t('header:zoom-switcher:aria-label')}
        onClick={handleButtonClick}
      >
        <TextAa size={20} data-testid="text-icon" />
      </IconButton>
      <Menu
        open={menuOpen}
        disableScrollLock
        defaultValue={zoom}
        onClose={handleMenuClose}
        anchorEl={menuAnchorEl}
        MenuListProps={{
          'aria-labelledby': 'zoom-button',
          disablePadding: false,
        }}
      >
        {['dense', 'normal', 'comfortable'].map((zoomDensity: ThemeZoom) => (
          <MenuItem key={zoomDensity} selected={zoom === zoomDensity} onClick={() => handleOnChange(zoomDensity)}>
            <Box component="span" sx={{ zoom: themeConstants.zoom[zoomDensity] }}>
              {t(`header:zoom-switcher:${zoomDensity}`)}
            </Box>
          </MenuItem>
        ))}
      </Menu>
    </>
  );
};
